<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="巡检事项 ">
              <a-input v-model="query.taskName" placeholder="请输入巡检事项 " allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="负责人">
              <a-input v-model="query.principal" placeholder="请输入负责人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item label="开始时间">
              <a-range-picker v-model="Uploadtime" @change="onChanget" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="结束时间">
              <a-date-picker format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" v-model="query.endTime" />
            </a-form-item>
          </a-col> -->
        </a-row>
        <a-row>
          <a-col :md="6" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="PatrolAdd()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <!-- <a-button
                type="primary"
                style="margin-left: 8px"
                @click="exportHandle()"
                v-action:export
              >导出</a-button>-->
            </span>
          </a-col>
        </a-row>
        <!-- <a-row :gutter="48">

        </a-row>-->
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <!-- <a @click="editHandle(record)" v-action:edit>编辑</a>
        <a-divider type="vertical" /> -->
        <a @click="goDetails(record)">详情</a>
      </span>
      <span slot="planTime" slot-scope="text" v-if="text !== null">{{ text }} 天</span>
      <span slot="lastInspectionDate" slot-scope="text" v-if="text !== null">{{
        moment(text).format('YYYY-MM-DD')
      }}</span>
      <span slot="nextInspectionDate" slot-scope="text" v-if="text !== null">{{
        moment(text).format('YYYY-MM-DD')
      }}</span>
    </a-table>

    <patrol-modal ref="PatrolModal" @handleOk="queryList"></patrol-modal>
    <detail-modal ref="DetailModal"></detail-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import PatrolModal from './modules/PatrolModal'
import DetailModal from './modules/DetailModal'
import moment from 'moment'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 100,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '巡检事项',
    dataIndex: 'taskName',
  },
  {
    title: '片区',
    dataIndex: 'zoneName',
  },
  {
    title: '负责人',
    dataIndex: 'principalName',
  },
  {
    title: '协办人',
    dataIndex: 'assistPersonName',
  },
  {
    title: '巡检周期',
    dataIndex: 'inspectionFrequency',
  },
  {
    title: '上次巡检日期',
    dataIndex: 'lastInspectionDate',
    scopedSlots: { customRender: 'lastInspectionDate' },
  },
  {
    title: '下次巡检日期',
    dataIndex: 'nextInspectionDate',
    scopedSlots: { customRender: 'nextInspectionDate' },
  },
  {
    title: '计划处理时长',
    dataIndex: 'planTime',
    scopedSlots: { customRender: 'planTime' },
  },
  // {
  //   title: '实际巡检次数',
  //   dataIndex: 'actualInspectionTimes'
  // },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    PatrolModal,
    DetailModal,
  },
  name: 'PatrolManagement',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/inspection_managements/page',
      deleteUrl: '/pipe-network/inspection_managements',
      addOrUpdateUrl: '/pipe-network/inspection_managements',
      queryOneUrl: '/pipe-network/inspection_managements',
      //   exportDataUrl: 'pipe-network/tenant_events/export',
      //   exportFileName: '事件管理表.xlsx',
      query: {
        startTime: '',
        endTime: '',
        principalName: '',
        sysType: '巡检',
        taskName: '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      Uploadtime:[],
      addOrUpdateForm: {
        eventName: '',
        eventType: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        accessorys: [],
      },
    }
  },
  filters: {},
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    resetList() {
      this.query = {
        startTime: '',
        endTime: '',
        principalName: '',
        sysType: '巡检',
        taskName: '',
      }
      this.pagination.current = 1
      this.Uploadtime = []
      this.selectedRows = []
      this.queryList()
    },
    onChanget(value, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
      console.log(this.query.startTime, '开始', this.query.endTime, '结束')
    },
    moment,
    goDetails(record) {
      this.$refs.DetailModal.edit(record.id)
    },
    EndOnChange(date, dateString) {
      this.query.endTime = dateString
    },
    StartOnChange(date, dateString) {
      this.query.startTime = dateString
    },
    PatrolAdd() {
      this.$refs.PatrolModal.edit()
    },
    editHandle(record) {
      this.$refs.PatrolModal.edit(record.id)
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
